import * as React from 'react';

interface Props {
  src: string;
  alt: string;
  className?: string;
  onError?: React.ReactEventHandler<HTMLImageElement> | undefined;
}

const Image: React.FC<Props> = ({ src, alt, className, onError }) => <img className={className || ''} src={src} onError={onError} alt={alt} />;

export default Image;
